import React, { ReactNode } from 'react'
import { PureComponent } from "react"
import { DispatchProp, connect } from "react-redux"
import StyledDiv from './styles'
import { IStoreState } from '../../../store/states'
import { images } from '../../../images'
import { ValidatedInput } from '../../../components'
import { searchStopsAction } from '../../../store/actions'
import { LiteralsService } from '../../../services'
import theme from '../../../theme'

interface IProps extends DispatchProp<any> {
  nameStopSearched: string
  isSearching: boolean
  isEveryFieldValid: boolean
  filterOpened: boolean
  moreThanOneServiceInfo: boolean
  onSearchPress: (isSearching: boolean) => {}
  onFilterPress: (show?: boolean) => {}
}
class StopSearchHeader extends PureComponent<IProps> {

  constructor(props: IProps) {
    super(props)
  }
  
  public render(): ReactNode {

    const { nameStopSearched } = this.props

    return (
      <StyledDiv>
        <div className='search-container'>
          <div className='search-icon'>
            <img src={ images['lens'] } alt='search' />
          </div>
          <ValidatedInput 
            label=''
            name='searchInput'
            value={nameStopSearched}
            onChange={ this.handleSearchChange }
            onFocus={ this.handleFocusChange }
            containerStyles={{
              margin: '0'
            }}
            styles={{
              borderBottom: 'none',
              paddingLeft: '40px',
              border: `solid 1px ${theme.colors.grey}`,
              borderRadius: '4px'
            }}
            placeholder={ LiteralsService.get('searchDirectionOrStop', true) }
          />
          <div className='buttons-container'>
            {
              nameStopSearched && nameStopSearched !== '' &&
              <img src={ images['cross'] } alt='clear' onClick={ this.handleClearSearch } />
            }
            { this.props.moreThanOneServiceInfo && <img src={ images['filter'] } alt='filter' onClick={ this.handleFilterClick } /> }
          </div>
        </div>
      </StyledDiv>
    )
  }

  private handleSearchChange = (value: string) => {
    const { dispatch } = this.props

    dispatch(searchStopsAction(value))
  }

  private handleFocusChange = (focused: boolean) => {
    const { onFilterPress, onSearchPress } = this.props
    let timeoutTime = focused ? 0 : 100
    if (focused) onFilterPress(false)
    setTimeout(() => {
      onSearchPress(focused)
    }, timeoutTime)
  }

  private handleClearSearch = () => {
    const { dispatch } = this.props

    dispatch(searchStopsAction(''))
  }

  private handleFilterClick = () => {
    const { onFilterPress } = this.props

    onFilterPress()
  }
}

const mapStateToProps = ({ newReservation }: IStoreState) => ({
  nameStopSearched: newReservation.nameStopSearched,
  isSearching: newReservation.isSearching,
  isEveryFieldValid:
    !!newReservation.pickedOriginBusStop &&
    !!newReservation.pickedDestinationBusStop
})

export default connect(mapStateToProps)(StopSearchHeader)